import { render, staticRenderFns } from "./contestacion.vue?vue&type=template&id=1b993de1"
import script from "./contestacion.vue?vue&type=script&lang=js"
export * from "./contestacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports